import { Response } from 'miragejs';
import config from 'garaje/config/environment';

/**
 * Sets up routes used by growth
 */
export default function () {
  this.urlPrefix = config.growthApiHost;

  this.get('/a/growth/api/v1/feature-impressions', () => {
    return new Response(200, {}, []);
  });

  this.post('/a/growth/api/v1/feature-impressions', () => {
    return new Response(200, {}, {});
  });

  this.get('/a/growth/api/v1/feature-setup', () => {
    return new Response(200, {}, []);
  });

  this.get('/a/growth/api/v1/company-infos/:id', (schema, request) => {
    return schema.companyInfos.find(request.params.id);
  });

  this.post('/a/growth/api/v1/feature-setup', () => {
    return new Response(200, {}, {});
  });

  this.get('/a/growth/api/v1/homepage-groups');
  this.patch('/a/growth/api/v1/homepage-items/:id');
  this.get('/a/growth/api/v1/setup-guide-items');
  this.patch('/a/growth/api/v1/setup-guide-items/:id');
}
